import { url } from '@/config';
import request from '../axios';
export const getList = (params) => {
  return request({
    url: url + '/role/list',
    method: 'get',
    params: params
  })
}

export const judge = (params) => {
  return request({
    url: url + '/role/judge',
    method: 'get',
    params: params
  })
}

export const getDetail = (id) => {
  return request({
    url: url + '/role/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const addObj = (row) => {
  return request({
    url: url + '/role/submit',
    method: 'post',
    data: row
  })
}

export const login = (row) => {
  return request({
    url: url + '/role/login',
    method: 'post',
    data: row
  })
}

export const updateObj = (row) => {
  return request({
    url: url + '/role/submit',
    method: 'post',
    data: row
  })
}

export const delObj = (id) => request({
  url: url + '/role/remove',
  method: 'post',
  params: {
    ids: id
  }
});


export const updatePwd = (row) => {
  return request({
    url: url + '/role/updatePwd',
    method: 'post',
    data: row
  })
}

export const updateToken = (row) => {
  return request({
    url: url + '/role/updateToken',
    method: 'post',
    data: row
  })
}

export const refreshToken = (row) => {
  return request({
    url: url + '/visual/refreshToken',
    method: 'post',
    data: row
  })
}